import React from 'react';

import { mapped_text } from './logic';

const one_line = (h) => String(h).replace(/\s+/g, ' ');

// One sheet column the compare did not recognise: Ignore / Same as <ours> / Add into <ours>.
const MapSelect = ({ id, column, targets, on_map, busy }) => (
  <span className={`tp-fsel tp-st-map-sel ${column.value ? 'is-on' : ''}`.trim()}>
    <label htmlFor={id} className="tp-fsel-k">
      Use as:
    </label>
    <select
      id={id}
      className="tp-fsel-in"
      aria-label={`How to use your column ${one_line(column.header)}`}
      value={column.value}
      disabled={busy}
      aria-describedby={column.error ? `${id}-err` : undefined}
      onChange={(e) => on_map(column.match_key, e.target.value)}
    >
      <option value="">{column.value ? 'Clear mapping' : 'Not used (not recognised)'}</option>
      <option value="ignore">Ignore</option>
      <optgroup label="Same as our column">
        {targets.map((t) => (
          <option key={`same:${t.key}`} value={`same:${t.key}`}>
            Same as {one_line(t.header)}
          </option>
        ))}
      </optgroup>
      <optgroup label="Add into our column">
        {targets.map((t) => (
          <option key={`add:${t.key}`} value={`add:${t.key}`}>
            Add into {one_line(t.header)}
          </option>
        ))}
      </optgroup>
    </select>
    <span className="tp-fsel-chev" aria-hidden="true" />
  </span>
);

/*
 * Mapping for the sheet's unrecognised columns, shared by the whole Ops team (saved in goserver);
 * the compare reruns as soon as a choice is saved. Older server: this session only, said so.
 */
const ColumnMapping = ({ mapping, on_map }) => {
  const { columns, targets, mapped, conflicts, saved, errors = {}, busy } = mapping;
  if (!columns.length) return null;
  return (
    <div className="tp-card" aria-label="Map your columns" role="group">
      <div className="tp-card-hd">
        <span className="tp-card-hd-main">
          <span className="tp-card-hd-title">Map your other columns</span>
          <span className="tp-card-hd-sub">
            {saved
              ? 'Saved for the whole Ops team; used for every sheet you compare'
              : 'Not saved: used in this session only'}
          </span>
        </span>
      </div>
      <div className="tp-st-body">
        {columns.length ? (
          <ul className="tp-st-map">
            {columns.map((c, i) => (
              <li key={c.match_key} className="tp-st-map-row">
                <span className="tp-st-map-hd">{one_line(c.header)}</span>
                <MapSelect
                  id={`tp-st-map-${i}`}
                  column={{ ...c, error: errors[c.match_key] }}
                  targets={targets}
                  on_map={on_map}
                  busy={busy === c.match_key}
                />
                {errors[c.match_key] ? (
                  <span id={`tp-st-map-${i}-err`} className="tp-st-map-err tp-neg" role="alert">
                    {errors[c.match_key]}
                  </span>
                ) : null}
              </li>
            ))}
          </ul>
        ) : (
          <p className="tp-st-note">Every column in this sheet is recognised.</p>
        )}
        {mapped.length ? (
          <p className="tp-st-note tp-st-mapped">
            <strong>{saved ? 'Mapped by Ops:' : 'Mapped this session (not saved):'}</strong>{' '}
            {mapped.map(mapped_text).join(' · ')}
          </p>
        ) : null}
        {conflicts.map((c) => (
          <div key={c.header} className="tp-banner tp-banner-warn tp-st-map-conflict">
            {c.text}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColumnMapping;
